import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { OPERATOR } from "@/lib/legal";
import { setSeo } from "@/lib/seo";

export const LEGAL_LINKS = [
  { to: "/kontakt", label: "Kontakt" },
  { to: "/impressum", label: "Impressum" },
  { to: "/datenschutz", label: "Datenschutz" },
  { to: "/nutzungsbedingungen", label: "Nutzungsbedingungen" },
  { to: "/barrierefreiheit", label: "Barrierefreiheit" },
  { to: "/quellen", label: "Quellen & Lizenzen" },
];

export const P = ({ children }) => <p className="mt-3 leading-relaxed text-foreground/85">{children}</p>;
export const UL = ({ items }) => <ul className="mt-3 space-y-2">{items.map((i, n) => <li key={n} className="flex gap-3 leading-relaxed text-foreground/85"><span className="mt-2.5 h-1 w-3 shrink-0 bg-terracotta" />{<span>{i}</span>}</li>)}</ul>;
export const A = ({ href, children }) => <a href={href} target="_blank" rel="noreferrer" className="text-ocean underline underline-offset-4 hover:text-terracotta">{children}</a>;

export const LegalLayout = ({ eyebrow, title, summary, sections, testid }) => {
  useEffect(() => { setSeo({ title }); }, [title]);
  return (
    <div data-testid={testid}>
      <div className="mx-auto max-w-[1400px] px-5 pb-8 pt-14 md:px-10 md:pt-20">
        <p className="eyebrow rise text-terracotta">{eyebrow}</p>
        <h1 className="rise rise-1 mt-3 text-4xl tracking-tight sm:text-5xl lg:text-6xl">{title}</h1>
        <p className="rise rise-2 mt-4 text-sm text-muted-foreground">Stand: {OPERATOR.updated}</p>
      </div>
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-12 px-5 md:px-10 lg:grid-cols-12">
        <nav className="hidden lg:col-span-3 lg:block" aria-label="Inhalt">
          <div className="sticky top-28 space-y-1 border-l border-foreground/15 pl-4 text-sm" data-testid="legal-toc">
            <p className="eyebrow mb-3 text-muted-foreground">Inhalt</p>
            {sections.map((s) => <a key={s.id} href={`#${s.id}`} className="block py-1 text-foreground/70 transition-colors hover:text-terracotta">{s.title}</a>)}
          </div>
        </nav>
        <article className="min-w-0 max-w-3xl lg:col-span-9">
          {summary && (
            <div className="border-l-2 border-terracotta bg-white/60 p-6" data-testid="legal-summary">
              <p className="eyebrow flex items-center gap-2 text-terracotta"><Sparkles size={14} /> Kurz gesagt</p>
              <UL items={summary} />
            </div>
          )}
          {sections.map((s) => (
            <section key={s.id} id={s.id} className="scroll-mt-28 border-b border-foreground/10 py-8">
              <h2 className="font-display text-2xl tracking-tight">{s.title}</h2>
              {s.body}
            </section>
          ))}
          <div className="flex flex-wrap gap-2 pt-8" data-testid="legal-nav">
            {LEGAL_LINKS.map((l) => <Link key={l.to} to={l.to} className="border border-foreground/15 bg-white/50 px-3 py-1.5 text-sm hover:bg-white">{l.label}</Link>)}
          </div>
        </article>
      </div>
    </div>
  );
};
